import Plyr from 'plyr';

export default {
  install: function(Vue,) {
    Object.defineProperty(Vue.prototype, '$player', { value: Plyr });
  }
}